import React from "react";
import { useNavigate , Link} from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-ai-04.jpg";
import aiImg from "../../assets/img/ai-WISserch.png";
import aiIcon01 from "../../assets/img/icon-ai12.png";
import aiIcon02 from "../../assets/img/icon-ai06.png";
import aiIcon03 from "../../assets/img/icon-ai13.png";
import aiIcon04 from "../../assets/img/icon-ai14.png";
import fwImg from "../../assets/img/fw-wisserch.png";

function WISserch() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

  //이미지 클릭
  const imgClick = () => {
    const img = new Image();
    img.src = fwImg;

    img.onload = () => {
      // 이미지 실제 원본 크기 가져오기
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;
      
      // 창 크기를 1200px로 고정하고 반응형으로 조정, 높이는 이미지 비율에 맞춤
      const w = Math.min(1200, window.innerWidth * 0.94);
      const aspectRatio = imgHeight / imgWidth;
      const h = w * aspectRatio;

      // 창을 현재 모니터 중앙에 위치시키기 (듀얼모니터 환경 고려)
      const currentScreenLeft = window.screen.availLeft || 0;
      const currentScreenWidth = window.screen.availWidth;
      const left = currentScreenLeft + (currentScreenWidth - w) / 2;
      const top = (window.screen.height - h) / 2;

      // HTML 페이지를 만들어서 이미지와 파비콘을 함께 표시
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="ko">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>WISsearch 프레임워크</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
              overflow: auto;
            }
            .image-container {
              width: 100%;
              height: 100%;
              text-align: center;
              padding: 0;
              overflow: visible;
            }
            .image-container img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              cursor: pointer;
              transition: transform 0.3s ease;
              transform-origin: top left;
            }
            .image-container img.zoomed {
              cursor: zoom-out;
            }
          </style>
          <script>
            function toggleZoom(img) {
              if (img.classList.contains('zoomed')) {
                // 축소: 원본 크기로
                img.style.transform = 'scale(1.0)';
                img.classList.remove('zoomed');
              } else {
                // 확대: 1.5배 또는 이미지 원본 크기 제한
                const imgNaturalWidth = ${imgWidth};
                const containerWidth = ${w};
                const scale1_5 = 1.5;
                const scale1_5Width = containerWidth * scale1_5;
                
                // 1.5배 크기가 이미지 원본보다 크면 원본 크기로, 작으면 1.5배로
                let finalScale;
                if (scale1_5Width > imgNaturalWidth) {
                  finalScale = imgNaturalWidth / containerWidth;
                } else {
                  finalScale = scale1_5;
                }
                
                img.style.transform = 'scale(' + finalScale + ')';
                img.classList.add('zoomed');
              }
            }
          </script>
        </head>
        <body>
          <div class="image-container">
            <img src="${fwImg}" alt="WISaicc 프레임워크" onclick="toggleZoom(this)" />
          </div>
        </body>
        </html>
      `;

      // 새 창 열기 - 이미지 비율에 맞춘 높이로
      const newWindow = window.open(
        "",
        "_blank",
        `width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no,status=no`
      );

      if (newWindow) {
        newWindow.document.write(htmlContent);
        newWindow.document.close();
      }
    };
  };

  //파일다운로드
    const downloadFile = async () => {
    const response = await fetch("/download/brochure");
    const blob = await response.blob();
  
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "위피아_AI솔루션.pdf";
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };
    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
            <span className="ko">AI 검색 솔루션</span>
						<h2>WISsearch</h2>
						<p>직관적인 자연어 질의로 원하는 정보를 빠르게 찾는 AI 기반 검색 솔루션입니다. 다양한 내부 시스템, 챗봇, 포털 등과 연동해 정보 접근성·업무 자동화·혁신적인 검색 경험을 제공합니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my ai-business-wrap">
        <section className="aiCont">
          <h4 className="title">
            <span>연관 솔루션</span>
          </h4>

          <h5 className="title">기업·기관의 비즈니스 프로세스를 혁신하세요!</h5>
          <p className="text">조직 내 모든 유형의 <span className="blue">AI 서비스와 데이터</span>를 손쉽게 연결하고, 통합된 환경에서 안전하게 운영·확장할 수 있는 엔터프라이즈 AI 허브이자, 업무 혁신의 디지털 플랫폼입니다.<br/>
          <span className="blue">복수의 AI 엔진, 멀티모달 데이터, 외부/기존 IT 시스템 및 다양한 채널</span>과의 연계를 필요로 하는 기업·기관에 특히 적합합니다.<br/>
          플랫폼 도입 시 즉각적 디지털 전환 효과와 <span className="blue">지속적 AI 확장 기반</span>을 함께 확보할 수 있습니다.</p>
          <ul className="link-wrap">
            <li> <Link to="/WISplatform">WISplatform <i></i></Link></li>
            <li> <Link to="/WISaicc">WISaicc <i></i></Link></li>
            <li> <Link to="/WISbot">WISbot <i></i></Link></li>
            <li> <Link to="/WISvec">WISvec <i></i></Link></li>
            <li> <Link to="/WISrag">WISrag <i></i></Link></li>
            <li> <Link to="/WISdoc">WISdoc <i></i></Link></li>
            <li> <Link to="/WISscrap">WISscrap <i></i></Link></li>
            <li> <Link to="/WISocr">WISocr <i></i></Link></li>
            <li> <Link to="/WISvoice">WISvoice <i></i></Link></li>
            <li> <Link to="/WISvision">WISvision <i></i></Link></li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
          <span>WISsearch 이란?</span>
        </h4>
        <div className="textWrap">
            <div className="ai-ci"><img src={aiImg} alt="WISsearch" /></div>
            <div className="info">
              <p>WISsearch는 기업 내・외부 방대한 텍스트 및 이미지 데이터를 의미 단위로 인식・이해하여, 최적의 정보 검색 경험을 제공하는 고도화된 AI 기반 검색 플랫폼입니다.<br/>키워드 매칭에 국한되지 않고, 사용자의 질문 의도와 문맥까지 해석하여 실시간 의미 기반 검색, 요약형 결과 제공, 대량의 비정형 데이터 통합 검색이 가능합니다.</p>

              <ul className="list">
                <li>
                  <p className="tit">의미 기반 자연어 검색</p>
                  <p className="txt">단순 키워드를 넘어, 질문의 의도와 맥락을 파악한 자연어 질의 대응</p>
                </li>
                 <li>
                  <p className="tit">시맨틱・벡터 검색</p>
                  <p className="txt">딥러닝 임베딩(Embedding) 기술을 활용한 벡터 공간에서의 유사도 기반 검색</p>
                </li>
                 <li>
                  <p className="tit">통합 데이터 인덱싱 및 분류</p>
                  <p className="txt">정형・비정형 문서, 이미지, PDF, DB, 웹페이지 등 다양한 소스의 데이터 인덱싱</p>
                </li>
                 <li>
                  <p className="tit">검색 결과 요약 및 추천</p>
                  <p className="txt">LLM 기반 문서 요약 출력, 관련 키워드・문서・연관 정보 자동 추천</p>
                </li>
                <li>
                  <p className="tit">멀티모달 검색 지원</p>
                  <p className="txt">텍스트, 이미지, 표, 첨부 자료 등 다양한 데이터 포맷에 대한 통합 검색 가능</p>
                </li>
                <li>
                  <p className="tit">최적화된 UX</p>
                  <p className="txt">사용자 맞춤형 검색 UI/UX 구현(필터, 랭킹, 하이라이트, 다운로드 지원 등)</p>
                </li>
              </ul>
            </div>
        </div>
        </section>

        <section className="aiCont">
          <h4 className="title ">
            <span>특장점</span>
          </h4>
          <ul className="textWrap feature-list">
            <li>
              <span className="icon"><img src={aiIcon01} alt="시맨틱 검색, 벡터 임베딩"/></span>
              <p className="tit">시맨틱 검색, <br/>벡터 임베딩</p>
              <p className="txt">자연어 이해력이 높은 딥러닝 모델로 의도 중심의 결과 제공</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon02} alt="실시간·자동화"/></span>
              <p className="tit">실시간· <br/>자동화</p>
              <p className="txt">인덱싱/업데이트/요약/추천 전 과정을 실시간 및 배치로 자동화</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon03} alt="멀티소스 통합"/></span>
              <p className="tit">멀티소스<br/>통합</p>
              <p className="txt">문서·이미지·DB 등 다양한 데이터 자동 인덱싱 및 통합 관리</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon04} alt="보안 접근제어"/></span>
              <p className="tit">보안<br/>접근제어</p>
              <p className="txt">기업별 권한·보안정책 적용, 감사/통계 기능 내장</p>
            </li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
            <span>아키텍처</span>
          </h4>
          <ul className="textWrap ac-list">
              <li>
                <p className="tit">데이터 수집 및 연동</p>
                <p className="txt">(다양한 소스에서 실시간/주기적 수집)</p>
              </li>
              <li>
                <p className="tit">데이터 전처리 및 인덱싱</p>
                <p className="txt">(정형/비정형 데이터 클렌징, 메타데이터 생성, 인덱싱 처리)</p>
              </li>
              <li>
                <p className="tit">의미 기반 임베딩 생성</p>
                <p className="txt">(딥러닝 임베딩으로 벡터화)</p>
              </li>
              <li>
                <p className="tit">사용자 질의 분석 및 임베딩 </p>
                <p className="txt">(자연어 질의의 의미 분석 및 임베딩 변환)</p>
              </li>
              <li>
                <p className="tit">벡터/시맨틱 유사도 검색</p>
                <p className="txt">(유사성 높은 데이터 다중 동시 검색)</p>
              </li>
              <li>
                <p className="tit">검색 결과 출력</p>
                <p className="txt">(요약, 문서 추천, 맞춤형 UI로 실시간 검색결과 제공)</p>
              </li>
            </ul>
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>프레임워크</span>
          </h4>
          <div className="textWrap framework">
              <img src={fwImg} alt="WISsearch 프레임워크" onClick={imgClick} />
          </div>
          
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>활용사례</span>
          </h4>
          <ul className="textWrap case-list">
              <li>
                <p className="tit">기업 사내 포털/정보 검색</p>
                <p className="txt">방대한 사내 문서, 정책, 규정, 매뉴얼, 프로젝트 자료 실시간 의미 기반 검색</p>
              </li>
                <li>
                <p className="tit">고객지원/FAQ 고도화</p>
                <p className="txt">고객 문의 시 자연어로 핵심 답변 제공, 유사 이슈/매뉴얼/도움말 자동 추천</p>
              </li>
                <li>
                <p className="tit">이메일・보고서・이미지 검색</p>
                <p className="txt">사용설명서, 기술문서 등에서 답변 근거를 함께 제시하는 전문 응대</p>
              </li>
                <li>
                <p className="tit">연관형/전문 데이터 탐색</p>
                <p className="txt">논문, 특허, 법률문서 등에서 복잡한 연관성 또는 유사자료 빠른 탐색</p>
              </li>
          </ul>
          
        </section>

        <section className="aiCont">
          <div className="btnWrap">
            <button type="button" className="inquiry-btn" onClick={downloadFile}>브로슈어 다운로드</button>
          </div>
        </section>
        
			</section>
		</main>
	<Footer />

        </>
    )
}

export default WISserch;